import React, { useState, useMemo, useRef, useEffect } from 'react'
import styles from './ProjectPage.module.css'
import ProgramHeader from '../ReusableComponents/Header/ProgramHeader'
import { useHistory } from 'react-router'
import renderPrgImage from '../../source/programImg'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { projectsDetails } from '../../utils/projectsDetails'
import { connect } from 'react-redux'
import '@google/model-viewer'
import renderImage from '../../source/importImg'
import renderCompImg from '../../source/Comp_Img'

const ProjectPage = (props) => {
    const { selectedKit } = props
    const viewerRef = useRef(null)

    const [animations, setAnimations] = useState([])
    const [index, setIndex] = useState(0)
    const [isShowUploadPopUp, setIsShowUploadPopUp] = useState({
        isShow: false,
        isUploadComplete: false,
        message: '',
    })

    let history = useHistory()

    // // Get project details from selectedKit and selectedProjectId
    // const projectDetails = useMemo(() => {
    //     if (!props?.selectedKit?.id || !props?.learn) {
    //         return null
    //     }
    //     const kitProjects = projectsDetails[props.selectedKit.id]
    //     if (!kitProjects || !kitProjects.projectList) {
    //         return null
    //     }
    //     const project = kitProjects.projectList.find(
    //         (p) => p.id === props.learn
    //     )
    //     return project || null
    // }, [props?.selectedKit?.id, props?.learn])

    // Calculate total slides based on GLB animations
    // const totalSlides = useMemo(() => {
    //     // This will be set dynamically when the GLB loads
    //     // For now, return 1 as default
    //     return selectedKit?.animationSlides || 1
    // }, [selectedKit?.animationSlides])

    const handelBack = () => {
        history.push('/Selection')
    }

    const handelUploadBtnClick = () => {
        setIsShowUploadPopUp({
            isShow: true,
            isUploadComplete: false,
            message: 'Program Uploading...',
        })

        setTimeout(() => {
            setIsShowUploadPopUp({
                isShow: true,
                isUploadComplete: true,
                message: 'Program Uploaded',
            })

            // setTimeout(() => {
            //     setIsShowUploadPopUp({
            //         isShow: false,
            //         isUploadComplete: false,
            //         message: '',
            //     })
            // }, 5000)
        }, 6000)
    }

    const handlePlayBtnClick = () => {
        history.push('/introduction')

        setIsShowUploadPopUp({
            isShow: false,
            isUploadComplete: false,
            message: '',
        })
    }

    useEffect(() => {
        const viewer = viewerRef.current
        if (!viewer) return

        const onLoad = () => {
            const anims = viewer.availableAnimations || []
            setAnimations(anims)

            // IMPORTANT: do NOT autoplay
            viewer.autoplay = false
            // viewer.pause()
        }

        const onFinish = () => {
            // Stop animation after one play
            viewer.autoplay = false
            viewer.pause()
        }

        viewer.addEventListener('load', onLoad)
        viewer.addEventListener('finished', onFinish)

        return () => {
            viewer.removeEventListener('load', onLoad)
            viewer.removeEventListener('finished', onFinish)
        }
    }, [])

    const playAnimation = (newIndex) => {
        const viewer = viewerRef.current
        if (!viewer || animations.length === 0) return

        viewer.pause() // stop any running animation
        viewer.animationName = animations[newIndex]
        viewer.currentTime = 0 // start from beginning
        viewer.loop = false
        setTimeout(() => {
            viewer.play()
        }, 10)

        setIndex(newIndex)
    }

    const handleNextSlide = () => {
        playAnimation((index + 1) % animations.length)
    }

    const handlePreviousSlide = () => {
        playAnimation((index - 1 + animations.length) % animations.length)
    }

    const optionsToSelect = () => {
        return [
            {
                text: 'Play',
                disabled: !isShowUploadPopUp.isUploadComplete,
                do: () => handlePlayBtnClick(),
            },
        ]
    }

    return (
        <div className={styles.projectPage}>
            <DialogModal
                show={isShowUploadPopUp.isShow}
                text={
                    // props?.webSerial?.isConnected ?
                    true ? (
                        <div>
                            <div>
                                <img
                                    src={renderPrgImage('programploadImage')}
                                    about="zing sleep mood animation"
                                    height="100px"
                                    width="100px"
                                    style={{ borderRadius: '20px' }}
                                />
                            </div>
                            <p
                                style={{
                                    marginTop: '1rem',
                                    marginBottom: '1rem',
                                }}
                            >
                                {isShowUploadPopUp.message}
                            </p>
                        </div>
                    ) : (
                        <p>Please connect the device.</p>
                    )
                }
                showCloseBtn={false}
                // handleDialogModalClose={() => setIsShowSleepPopUp(false)}

                optionsToSelect={optionsToSelect()}
            />

            <div>
                <ProgramHeader
                    data={
                        {
                            // options: [projectName, '', ''],
                            // selected: -1,
                        }
                    }
                    styles={{
                        headerBar: {
                            backgroundColor: '#f9eced',
                        },
                    }}
                    showSave={false}
                    showHelp={false}
                    handleHelp={<></>}
                    isShowTitle={true}
                    singleTitle={`${selectedKit.device}: ${selectedKit.name}`}
                    // isShowBack={true}
                    // goBack={handelBack}
                />
            </div>

            <div className={styles.projectBodyDiv}>
                <div className={styles.projectBody}>
                    {/* --------- Animation Viewer ------------------------------- */}

                    {selectedKit?.animation ? (
                        <div className={styles.showAnimation}>
                            <model-viewer
                                ref={viewerRef}
                                src={renderPrgImage(selectedKit.animation)}
                                camera-controls
                                autoplay={false}
                                animation-loop={false}
                                style={{ width: '100%', height: '100%' }}
                            />
                        </div>
                    ) : (
                        <div
                            className={styles.showAnimation}
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <p>No animation available for this project</p>
                        </div>
                    )}
                </div>

                <div className={styles.projectPageSidebarDiv}>
                    <div className={styles.projectPageSidebar}>
                        {selectedKit?.assetsList?.[index]?.map((img) => (
                            <img
                                style={{
                                    width: '130px',
                                    marginTop: '10px',
                                    marginBottom: '20px',
                                }}
                                className={styles.sidebarAssetsImg}
                                src={renderPrgImage(img)}
                                alt={img}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* --------- footer ------------------------------- */}

            <img
                onClick={() => handelBack()}
                // className="nextButton" //search for ".nextButton" in project directory to edit style
                id="uploadLogicscrn"
                src={renderImage('backBtn')}
                style={{
                    position: 'absolute',
                    visibility: 'visible',
                    // top: '91%',
                    bottom: '2%',
                    left: '2%',
                    width: '60px',
                    // height: '60px',
                    cursor: 'pointer',
                    opacity: '1',
                }}
            ></img>

            {index > 0 && (
                <img
                    onClick={() => handlePreviousSlide()}
                    // className="nextButton" //search for ".nextButton" in project directory to edit style
                    id="uploadLogicscrn"
                    src={renderPrgImage('previousArrowBtn')}
                    style={{
                        position: 'absolute',
                        visibility: 'visible',
                        // top: '91%',
                        bottom: '2%',
                        right: '10%',
                        width: '60px',
                        // height: '60px',
                        cursor: 'pointer',
                        opacity: '1',
                    }}
                ></img>
            )}

            {index < animations.length - 1 && (
                <img
                    onClick={() => handleNextSlide()}
                    id="uploadLogicscrn"
                    src={renderPrgImage('nextArrowBtn')}
                    style={{
                        position: 'absolute',
                        visibility: 'visible',
                        // top: '91%',
                        bottom: '2%',
                        right: '2%',
                        width: '60px',
                        // height: '60px',
                        cursor: 'pointer',
                        opacity: '1',
                    }}
                ></img>
            )}

            {animations.length != 0 && index >= animations.length - 1 && (
                <img
                    onClick={() => {
                        handelUploadBtnClick()
                    }}
                    // className="nextButton" //search for ".nextButton" in project directory to edit style
                    id="uploadLogicscrn"
                    src={renderPrgImage('uploadBtn')}
                    style={{
                        position: 'absolute',
                        visibility: 'visible',
                        // top: '91%',
                        bottom: '2%',
                        right: '2%',
                        width: '60px',
                        // height: '60px',
                        cursor: 'pointer',
                        opacity: '1',
                    }}
                ></img>
            )}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        selectedKit: state.device?.kitSelection?.selectedKit,
        // learn: state?.learn?.selectedProjectId ?? 'roverKitP1',
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        // setLanguageSelect: (data) => {
        //     dispatch(setLanguageSelect(data))
        // },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectPage)
